import React from "react";
import { useDispatch } from "react-redux";
import { setPreference } from "components/Preferences/preferencesActions";
import { BULLETIN } from "redux/slices/api/initialisePreferences";
import { useGetPreferences } from "api/preferences/useGetPreferences";
import { TextAlert } from "./TextAlert";

export function ServiceNotification() {
  const dispatch = useDispatch();
  const dismiss = () => dispatch(setPreference({ key: BULLETIN, value: "" }, true));
  const resp = useGetPreferences(BULLETIN);
  const msg = resp ? decodeURI(resp).trim() : null;

  return msg ? <TextAlert title={msg} onDismiss={dismiss} /> : null;
}
